// extracted by mini-css-extract-plugin
export default {"paper":"rymb6AZDR8ywXq2NcDV6","stars":"TQ1_ZniPLl7OujRIvJSQ","infoBox":"MmJxcHTRxSa_d7RNHaWW"};